import React, { Component } from 'react';
import { connect } from 'react-redux';
import searchIcon from 'images/ic-search-black.png';
import AudioPlayer, { RHAP_UI } from 'react-h5-audio-player';
import { asyncFetchAudios, resetAudiosSettings } from 'actions/bundles';
import Pagination from 'react-js-pagination';
import 'react-h5-audio-player/lib/styles.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './AudioList.scss';
import '@fortawesome/fontawesome-free/css/all.min.css';

export class AudioList extends Component {
  state = {
    searchFor: '',
    activePage: 1
  };

  componentDidMount() {
    const { fetchAudios, resetAudiosSettings } = this.props;
    resetAudiosSettings();
    fetchAudios();
  }

  handleKeyPress = event => {
    if (event.keyCode === 13) {
      const { fetchAudios, isAudiosLoading } = this.props;
      if (!isAudiosLoading) {
        fetchAudios(1, event.target.value);
        this.setState({ activePage: 1 });
      }
    }
  };

  handlePageChange = pageNumber => {
    const { fetchAudios } = this.props;
    fetchAudios(pageNumber);
    this.setState({ activePage: pageNumber });
  };

  render() {
    const { isAudiosLoading, audioList, audiosBatchSize, totalAudiosCount } = this.props;
    return (
      <div className="audio-list d-flex flex-column">
        <div className="audio-search-bar d-flex align-items-center">
          <img src={searchIcon} alt="" />
          <input className="flex-grow-1" type="text" placeholder="Search" onKeyDown={this.handleKeyPress} />
        </div>
        <div className="list">
          <div className="list-header d-flex justify-content-between">
            <h5>Title</h5>
            <h5>Duration</h5>
          </div>
          {audioList && audioList.length > 0 ? (
            <div className="list-content">
              {audioList.map((audio, i) => (
                <AudioPlayer
                  key={i}
                  layout="horizontal-reverse"
                  defaultDuration="Loading..."
                  src={audio.path}
                  autoPlay={false}
                  loop={true}
                  autoPlayAfterSrcChange={false}
                  showJumpControls={false}
                  customAdditionalControls={[]}
                  customVolumeControls={[]}
                  customProgressBarSection={[
                    <span className="audio-title">{audio.title}</span>,
                    RHAP_UI.PROGRESS_BAR,
                    RHAP_UI.DURATION
                  ]}
                />
              ))}
            </div>
          ) : (
            !isAudiosLoading && <p className="p-4">No audio found matching your criteria.</p>
          )}
          {isAudiosLoading && (
            <div className="loading">
              <i className="fas fa-spinner fa-spin" />
            </div>
          )}
        </div>
        <div className="page-bar-container">
          {audioList && totalAudiosCount > 0 && (
            <Pagination
              activePage={this.state.activePage}
              itemsCountPerPage={audiosBatchSize}
              totalItemsCount={totalAudiosCount}
              pageRangeDisplayed={5}
              onChange={this.handlePageChange.bind(this)}
              itemClass="page-item"
              linkClass="page-link"
            />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { audioList, totalAudiosCount, audiosCurrentPage, audiosBatchSize, isAudiosLoading } = state.bundles;
  return {
    isAudiosLoading,
    audioList,
    totalAudiosCount,
    audiosCurrentPage,
    audiosBatchSize
  };
};

const mapDispatchToProps = dispatch => ({
  resetAudiosSettings: () => dispatch(resetAudiosSettings()),
  fetchAudios: (curPage = 1, keyword) => dispatch(asyncFetchAudios(curPage, keyword))
});

export default connect(mapStateToProps, mapDispatchToProps)(AudioList);
